import { DialogService } from 'aurelia-dialog';
import { inject } from 'aurelia-framework';
import SortingCriteria from "../../../../Lib/Fs.Core.Data/SortingCriteria";
import PagingCriteria from "../../../../Lib/Fs.Core.Data/PagingCriteria";
import { I18N } from 'aurelia-i18n';
import FsUtility from '../../../../Lib/Fs.SmartClient.Client/FsUtility';
import { useView, autoinject, Container } from 'aurelia-framework'
import { EventAggregator } from 'aurelia-event-aggregator';
import { PLATFORM } from 'aurelia-pal';
import NewsEditorVM from './NewsEditorVM';
import NewsData from '../../Scripts/AppServiceContract/NewsData';
import PublicNewsAppService from '../../Scripts/AppServiceContract/PublicNewsAppService';
import SearchVMBase2 from '../../../../Lib/Fs.SmartClient.Client/SearchVMBase2';
import PublicNewsCriteria from '../../Scripts/AppServiceContract/PublicNewsCriteria';
import PublicNewsSearchParameter from '../../Scripts/AppServiceContract/PublicNewsSearchParameter';
import { fs } from '../../../../Config/FsConfig';
import { Router } from 'aurelia-router';
import GeneralPopupEditorDialogVM from '../../../../Lib/Fs.Core.Aurelia/Components/GeneralPopupEditDialogVM';
import PickDateDialogVM from '../../Components/PickDateDialogVM';
import SearchVMBase from '../../../../Lib/Fs.SmartClient.Client/SearchVMBase';
import NewsTypeData from '../../Scripts/AppServiceContract/NewsTypeData';

@inject(DialogService)
@useView(PLATFORM.moduleName("./NewsSearchView.html"))
export default class NewsSearchVM extends SearchVMBase2<NewsEditorVM, PublicNewsCriteria>{
  public dialogService: DialogService;
  public i18n: I18N;
  public eventAggregator: EventAggregator;
  public AllType: boolean = false;
  public Showbutton: boolean = true;
  public NewsType: NewsTypeData[];

  changeLocaleSubscribe: any;

  EffectiveDateFrom: Date;
  EffectiveDateTo: Date;

  router: Router
  AttachmentBaseUrl: string;
  TextTitle: string;
  TextOK: string;

  constructor(dialogService) {
    super(NewsEditorVM);
    this.eventAggregator = Container.instance.get(EventAggregator);
    this.i18n = Container.instance.get(I18N);
    this.dialogService = dialogService;
    this.router = Container.instance.get(Router);
    this.FindNewsType();
    this.Search();
    this.PageSize = 9;
    this.AttachmentBaseUrl = fs.Config.ServiceBaseUrl + "modules/Aqs.AppService/UploadFileAppService/DownloadFile/id=";
    /*this.changeLocaleSubscribe = this.eventAggregator.subscribe('ChangeLocale', (response) => {
      this.Search();
      this.Translate();
    });
    var self = this;
    setTimeout(function () {
      self.Translate();
    }, 3000);*/
  }

  Translate() {
    this.TextTitle = this.i18n.tr('Aqs.News:NewsPage.ChooseDateRange');
    this.TextOK = this.i18n.tr('Aqs.News:NewsPage.Search');
  }

  CreateCriteria(): PublicNewsCriteria {
    var self = this;
    const criteria = new PublicNewsCriteria();
    criteria.EffectiveDateForm = FsUtility.ToJsonDate(this.EffectiveDateFrom);
    criteria.EffectiveDateTo = FsUtility.ToJsonDate(this.EffectiveDateTo);
    criteria.NewsTypeId = this.NewsTypeId;
    return criteria;
  }

  SearchItems(searchCallback: (result: NewsData[]) => void, searchCriteria: PublicNewsCriteria, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria) {
    var self = this;
    const searchParameter = new PublicNewsSearchParameter();
    searchParameter.Criteria = searchCriteria;
    searchParameter.PagingCriteria = pagingCriteria;
    searchParameter.SortingCriteria = sortingCriteria;
    var service = this.container.get(PublicNewsAppService) as PublicNewsAppService;
    service.Find(searchParameter)
      .done((result) => {
        if (self.NewsTypeId == null) {
          self.NewsType.forEach(t => {
            var SlideShow = result.find(element => element.NewsTypeId == t.Id);
            var newEditorVM = new NewsEditorVM();
            newEditorVM.LoadOriginalSource(SlideShow);
            this.listSlideShow.unshift(newEditorVM);
            result.splice(result.findIndex(e => e.Id == SlideShow.Id), 1);
          })
          this.Showbutton = true;
          this.SelectShowNews = self.listSlideShow[0];
        }
        else {
          //debugger
          var newsSlideShow = result.shift();
          var newEditorVM = new NewsEditorVM();
          newEditorVM.LoadOriginalSource(newsSlideShow);
          self.NewsSlideShow = newEditorVM;
          this.Showbutton = false;
          this.SelectShowNews = self.NewsSlideShow;
        }
        searchCallback(result);
      })
      .fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  CountItems(searchCallback: (result: number) => void) {
    var self = this;
    var req = self.CreateCriteria();
    var service = this.container.get(PublicNewsAppService) as PublicNewsAppService;
    service.Count(req)
      .done((result) => {
        searchCallback(result)
      }).fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  Reset() {
    this.EffectiveDateFrom = null;
    this.EffectiveDateTo = null;
    this.Search();
  }

  ShowNews(data) {
    this.router.navigate('Modules/Aqs/NewsPage/' + data.Id);
  }

  PreparePaging() {
    this.PageSize += 3;
  }

  SelectDate() {
    this.IsEditing = true;
    this.dialogService = this.container.get(DialogService);
    this.dialogService.open({
      viewModel: PickDateDialogVM, model: {
        view: PLATFORM.moduleName("Modules/Aqs/Programs/News/NewsCriteriaView.html"),
        viewModel: this,
        Header: this.TextTitle,
        okbtnclass: "btn btn-sm btn-success",
        okbtn: this.TextOK,
      }, lock: true
    }).whenClosed(response => {
      if (response.wasCancelled) {
        this.EffectiveDateFrom = null;
        this.EffectiveDateTo = null;
      } else {
        this.EffectiveDateFrom = response.output.EffectiveDateFrom;
        this.EffectiveDateTo = response.output.EffectiveDateTo;
        this.Search();
      }
    });
  }

  FindNewsType() {
    var service = this.container.get(PublicNewsAppService) as PublicNewsAppService;
    service
      .FindNewsType()
      .done((result) => {
        this.NewsType = result;
      })
      .fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  public NewsTypeId: any;
  SelectNewsType(typeId) {
    //debugger
    var self = this;
    this.AllType = true;
    if (typeId != null) self.NewsTypeId = typeId;
    this.PageSize = 9;
    self.Search();
  }

  SelectNewsTypeAll() {
    this.NewsTypeId = null;
    this.AllType = false;
    this.PageSize = 9;
    this.Search();
  }

  public listSlideShow = [];
  public SelectShowNews: any;
  public NewsSlideShow: any;
  public ListNewsId: any;
  public NewsIndex: number;
  SelectNewsSlideShow(typeid) {
    //debugger
    var self = this;
    var tempTypeId = typeid;
    var NewsIndex = this.listSlideShow.findIndex(t => t.NewsTypeId == tempTypeId)
    self.NewsIndex = NewsIndex;
    this.SelectShowNews = this.listSlideShow[NewsIndex];
  }

}
